export const Estados = [
    { key: "A", value: "Activo" },
    { key: "I", value: "Inactivo" },
    { key: "", value: "Todos" }
]

export const Monedas = [
    { key: "", value: "Todos", symbol: "" },
    { key: "1585", value: "Pesos Colombianos", symbol: "COP " },
    { key: "1584", value: "Dólares", symbol: "$ " }
]

export const TiposFondo = [
    { "key": "G", "value": "Grupo Empresarial/Empresa" },
    { "key": "I", "value": "Inversionista" },
];

export const TiposTasa = [
    { "key": "D", "value": "Tasa Diaria" },
    { "key": "M", "value": "Tasa Mensual" },
    { "key": "A", "value": "Tasa Anual" }
];

export const TiposLinea = [
    { "key": "C", "value": "Crédito" },
    { "key": "B", "value": "Bono" }
];

export const TiposLineaGarantia = [
    { "key": "A", "value": "Abono" },
    { "key": "R", "value": "Retiro" }
];

export const TiposFrecuenciaPago = [
    { "key": "D", "value": "Diario" },
    { "key": "S", "value": "Semanal" },
    { "key": "M", "value": "Mensual" },
    { "key": "T", "value": "Trimestral" },
    { "key": "SM", "value": "Semestral" },
    { "key": "A", "value": "Anual" },
    { "key": "O", "value": "Por Operación" }
];

export const DiasSemana = [
    { "key": 0, "value": "Lunes" },
    { "key": 1, "value": "Martes" },
    { "key": 2, "value": "Miércoles" },
    { "key": 3, "value": "Jueves" },
    { "key": 4, "value": "Viernes" },
    { "key": 5, "value": "Sábado" },
    { "key": 6, "value": "Domingo" }
];

export const Meses = [
    { "key": 1, "value": "Enero" },
    { "key": 2, "value": "Febrero" },
    { "key": 3, "value": "Marzo" },
    { "key": 4, "value": "Abril" },
    { "key": 5, "value": "Mayo" },
    { "key": 6, "value": "Junio" },
    { "key": 7, "value": "Julio" },
    { "key": 8, "value": "Agosto" },
    { "key": 9, "value": "Setiembre" },
    { "key": 10, "value": "Octubre" },
    { "key": 11, "value": "Noviembre" },
    { "key": 12, "value": "Diciembre" }
];

export const TiposReglas = [
    { "key": 'P', "value": "Ponderativa" },
    { "key": 'R', "value": "Restrictiva" },
    { "key": 'W', "value": "Whitelist" }
];

export const CategoriasRegla = [
    { "key": 'Q', "value": "Numérica" },
    { "key": 'D', "value": "descriptiva" }
];

export const CriteriosComparacionRegla = [
    { "key": 'E', "value": "Igual a" },
    { "key": 'L', "value": "Menor a" },
    { "key": 'G', "value": "Mayor a" },
    { "key": 'LE', "value": "Menor o igual a" },
    { "key": 'GE', "value": "Mayor o igual a" },
    { "key": 'B', "value": "Entre los límites" },
    { "key": 'N', "value": "No es igual a" },
    { "key": 'I', "value": "Pertenece a una lista de valores" }
];

export const TablasRegla = [
    {
        "key": 'DN', "value": "Documentos Negociables",
        "campos": ["VNPP", "Tipo de Comprobante", "Rubro"]
    },
    {
        "key": 'EMP', "value": "Empresas",
        "campos": ["Pais"]
    },
    {
        "key": 'PROV', "value": "Proveedores",
        "campos": ["Scoring Puntaje", "Estado Comercial", "Condicion"]
    },
    {
        "key": 'ADQ', "value": "Adquirentes",
        "campos": ["Scoring Puntaje", "Sector Económico"]
    },
    {
        "key": 'INV', "value": "Inversionistas",
        "campos": ["Scoring Puntaje"]
    }
];

export enum ACCION_FONDO {
    REGISTRO_FONDO,
    MODIFICAR_DATOS_GENERALES_FONDO,
    MODIFICAR_LINEA_FONDO,
    MODIFICAR_SECTOR_FONDO,
    MODIFICAR_REGLA_FONDO
}

export enum ACCION_GARANTIA {
    REGISTRO_GARANTIA,
    MODIFICAR_DATOS_GARANTIA,
    CREAR_LINEA_GARANTIA
}

export class SectorFondoTemp {
    idFondo: number;
    idSector: number;
    Codigo_Sector: string;
    Nombre_Sector: string;
    Porcentaje: number;
    Monto_Sector_Fondo: number;
    nuevo: boolean;
}